'use client'

import dynamic from 'next/dynamic'
import { InsuranceGuideSkeleton } from '@/features/insuranceGuide/components/InsuranceGuide/InsuranceGuideSkeleton'
import { InsuranceGuideBlockContainer } from './InsuranceGuideBlockContainer'

export const InsuranceGuideBlockDynamic = dynamic(
  async () => {
    const { InsuranceGuideBlock } = await import('./InsuranceGuideBlock')
    return InsuranceGuideBlock
  },
  {
    ssr: false,
    loading: () => (
      <InsuranceGuideBlockContainer>
        <InsuranceGuideSkeleton />
      </InsuranceGuideBlockContainer>
    ),
  },
)
